export default "__VITE_ASSET__CMWNm$up__"